/**
 * Do these two list ids refer to the same list?
 *
 * Normalised rather than compared with ===. No path in this repo produces a string id today --
 * ids are integers from the API and reach props via lists.data -- but handleChangeList has always
 * matched loosely, and the two failure modes are not symmetric: a false negative here means
 * silently not saving, which is worse than the bug this guard exists to prevent. Normalising costs
 * nothing and removes the need for anyone to re-derive that (ARTFLT-1587).
 */
export const sameListId = (a, b) =>
  a !== null && a !== undefined && b !== null && b !== undefined && String(a) === String(b);
